import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { DETALIZATION_MODAL_COMMON } from 'constants/detalization';
import {
  BUTTON_CAPTION,
  COMMON_ERRORS,
} from 'constants/common';

// Components
import {
  Text,
  Button,
  Input,
} from '@beef/ui-kit';
import { Icon } from 'components';
import { BackButton } from '../BackButton';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const ConfirmationForm = ({
  isMobile,
  email,
  inputData,
  onGoBack,
  onSubmit,
  onReloadCode,
  isCodeSending,
  isCodeSendingError,
  isChecking,
  isCheckingError,
  isIncorrectConfirmationCode,
}) => {
  const disabled = inputData.value.length === 0;

  const errorCaption = isIncorrectConfirmationCode
    ? COMMON_ERRORS.INCORRECT_CONFIRMATION_CODE
    : COMMON_ERRORS.WENT_WRONG;

  return (
    <>
      <div className={cx('back-wrapper')}>
        <BackButton onClick={onGoBack} />
      </div>
      <Text size="size3-b">{DETALIZATION_MODAL_COMMON.PASSCODE_CAPTION}</Text>
      <div className={cx('info-text')}>
        <Text size="size5-r-l">{`${DETALIZATION_MODAL_COMMON.PASSCODE_INFO_MASSAGE}${email}`}</Text>
      </div>
      <form onSubmit={onSubmit}>
        <div className={cx('form')}>
          <div className={cx('input-wrapper')}>
            <Input
              label="Код подтверждения"
              name="password"
              {...inputData}
            />
          </div>
          <Button
            isLoading={isChecking}
            fullWidth={isMobile}
            size="m"
            type="submit"
            disabled={disabled}
          >
            {BUTTON_CAPTION.READY}
          </Button>
        </div>
        {(isCodeSendingError || isCheckingError) && (
          <div className={cx('error')}>
            <Text size="size5-r-l">{errorCaption}</Text>
          </div>
        )}
        <Button
          rightIcon={<Icon className={cx('reload-icon')} name="reload" />}
          size="m"
          type="button"
          variant="plain"
          onClick={onReloadCode}
          isLoading={isCodeSending}
        >
          {BUTTON_CAPTION.RELOAD}
        </Button>
      </form>
    </>
  );
};

ConfirmationForm.propTypes = {
  isMobile: PropTypes.bool,
  isCodeSending: PropTypes.bool,
  isCodeSendingError: PropTypes.bool,
  isChecking: PropTypes.bool,
  isCheckingError: PropTypes.bool,
  isIncorrectConfirmationCode: PropTypes.bool,
  email: PropTypes.string,
  inputData: PropTypes.string,
  onGoBack: PropTypes.func,
  onSubmit: PropTypes.func,
  onReloadCode: PropTypes.func,
};
